export enum IconTypes {
    Default = "",
    BookOpen = "fa-light fa-book-open",
    Calendar = "fa-light fa-calendar-alt",
    ChalkboardTeacher = "fa-light fa-chalkboard-teacher",
    Graduate = "fa-light fa-user-graduate",
    IdCard = "fa-light fa-id-card-alt",
    Megaphone = "fa-light fa-megaphone",
    Microscope = "fa-light fa-microscope",
    Mobile = "fa-light fa-mobile-alt",
    Portrait = "fa-light fa-portrait",
    University = "fa-light fa-university",
    HeadSideBrain = "fa-light fa-head-side-brain",
    ScreenUsers = "fa-light fa-screen-users"
}
